import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import './BackgroundImageTextSection.scss';

export default function BackgroundImageTextSection(props) {
  let stylesMobile = {
    backgroundImage: `url('${props.imgMobile}')`
  }

  let stylesDesktop = {
    backgroundImage: `url('${props.imgDesktop}')`
  }

  let row = `d-flex justify-content-${props.imgPosition === 'left' ? 'end': 'start'}`;
  let mobileAngle = `section-image-${props.overlayColor}-content-${props.mobileAngle === 'reverse' ? 'reverse': 'standard'}`;

  return (
    <section className={classNames(`section section-image-${props.overlayColor}-outside section-image-${props.overlayColor}-outside-${props.desktopAngle} section-image-${props.overlayColor}-offset-${props.offset}`, props.className,)}>
      <div className={classNames(`section-image-mobile section-image-${props.overlayColor}-${props.imgPosition} background-image-${props.backgroundPosition}`)} style={stylesMobile}/>
      <div className={classNames(`section-image-${props.overlayColor}-content section-image-${props.overlayColor}-content-${props.imgPosition} ${mobileAngle}`)}>
        <Container>
          <div className={classNames(`section-image-desktop section-image-${props.overlayColor}-${props.imgPosition} background-image-${props.backgroundPosition}`)} style={stylesDesktop}/>

          {props.title ? (
            <Row className="d-flex justify-content-center">
              <Col className={classNames(`${props.titleCols}`)}>
                <h2 className={classNames(`section-heading ${props.titleClass}`)}>{props.title}</h2>
              </Col>
            </Row>
          ) : ( null )}

          <Row className={row}>
            <Col className={props.colClass}>
              {props.children}
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
}

BackgroundImageTextSection.defaultProps = {
  overlayColor: "white",
  offset: "none",
  desktopAngle: "standard",
  colClass: "col-12 col-lg-7",
  titleClass: "text-center",
  titleCols: "col-12",
  backgroundPosition: "center"
}
